import {
  Tabs,
  Tab,
  Row,
  Col,
  Form as BForm
} from '@themesberg/react-bootstrap'
import { Formik } from 'formik'
import React, { useState } from 'react'
import GeneralForm from '../CreateBonus/general'
import useCreateBonus from '../hooks/useCreateBonus'
import CurrenciesForm from '../CreateBonus/currencies'
import { updateBonusStart } from '../../../../../store/redux-slices/bonus'
import { formatDateYMD } from '../../../../../utils/dateFormatter'
import useEditBonus from '../hooks/useEditBonus'
import Preloader from '../../../../../components/Preloader'
import { tabLabels } from '../CreateBonus/constants'
import { bonusSchema } from '../CreateBonus/schema'
import PaymentMethod from '../CreateBonus/PaymentMethod'
import WageringContributionForm from '../CreateBonus/wageringContribution'
import Games from '../CreateBonus/Games'
import { toast } from '../../../../../components/Toast'
import Languages from '../CreateBonus/Languages'
import BonusCountry from '../CreateBonus/BonusCountry'
import { safeStringify } from '../../../../../utils/helpers'

const EditBonus = () => {
  const {
    selectedTab,
    setSelectedTab,
    state,
    dispatch,
    bonusDetail,
    bonusId,
    portalOptions,
    loading,
    navigate,
    setState,
    countryData,
    setCountryData
  } = useEditBonus()

  const {
    handleImagePreview,
    preview,
    setActiveTab,
    setCurr,
    enableSubmit,
    setEnableSubmit,
    wageringTemplateList,
    wageringTemplateDetail,
    clientsFilterData,
    setSelectedClient,
    getBalanceBonusesOptions,
    balanceBonusOptions,
    pageNo,
    setPageNo,
    limit,
    setLimit,
    totalPages,
    gameIds,
    setGameIds,
    search,
    setSearch,
    casinoGamesData,
    selectedProvider,
    setSelectedProvider,
    selectedClient,
    gamesLimit,
    gamesPageNo,
    setGamesLimit,
    setGamesPageNo,
    appliedBonusOptions,
    languages,
    data,
    setData,
    set
  } = useCreateBonus(bonusDetail)
  const [loyaltyCount, setLoyaltyCount] = useState(1)

  return (
    <>
      <Row>
        <div className='section-header-wrap mt-n3 mx-n3'>
        <Col>
          <h3>Edit Bonus: {bonusDetail?.promotionTitle?.EN} </h3>
        </Col>
        </div>
       
      </Row>
      {!loading && set
        ? (
          <Formik
            enableReinitialize
            initialValues={{
              promotionTitle: bonusDetail?.promotionTitle?.EN || '',
              bonusType: bonusDetail?.bonusType || '',
              validFrom: bonusDetail?.validFrom || state.startDate,
              validTo: bonusDetail?.validTo || state.endDate,
              termCondition: bonusDetail?.termCondition?.EN || '',
              quantity: bonusDetail?.quantity || 0,
              daysToClear: bonusDetail?.daysToClear || 0,
              currency: bonusDetail?.currency || {},
              maxBonusThreshold: '',
              status: bonusDetail?.status || '',
              minDeposit: '',
              wageringRequirementType: bonusDetail?.wageringRequirementType || '',
              maxWinAmount: '',
              isWinCashAmt: '',
              isBonusWagering: '',
              depositBonusPercent: bonusDetail?.depositBonusPercent,
              // tenantIds: portalOptions.filter(
              //   (tenant) => tenant.value === bonusDetail?.tenantId
              // ),
              // adminId: bonusDetail?.adminId,
              validOnDays: bonusDetail?.validOnDays,
              bonusImage: null,
              isActive: bonusDetail?.isActive || false,
              showBonusValidity: bonusDetail?.other?.showBonusValidity,
              visibleInPromotions: bonusDetail?.visibleInPromotions || false,
              isSticky: bonusDetail?.isSticky || false,
              wageringMultiplier: bonusDetail?.wageringMultiplier || 1,
              paymentMethods: { [bonusDetail?.tenantId]: bonusDetail?.paymentMethods } || { [bonusDetail?.tenantId]: [] },
              wageringTemplateId: bonusDetail?.wageringTemplateId || '',
              appliedBonusId: '',
              appliedBonusVal: bonusDetail?.appliedBonusId,
              description: bonusDetail?.description?.EN || '',
              loyaltyLevel: bonusDetail?.other?.loyaltyLevel || [{}],
              minBalance: '',
              timePeriod: bonusDetail?.other?.timePeriod || '1',
              other: bonusDetail?.other?.loyaltyLevel || null,
              betLevel: bonusDetail?.other?.betLevel || 1
            }}
            validationSchema={
            bonusSchema(bonusDetail?.currency, { bonusDetail })[tabLabels.findIndex((val) => val === selectedTab)]
          }
            onSubmit={(formValues) => {
              Object.keys(formValues).forEach((key) => {
                if (formValues[key] === null || formValues[key] === '') {
                  delete formValues[key]
                }
              })

              const checkOther = (data) => {
                const other = typeof data === 'object' ? safeStringify(data) : data
                if (safeStringify(bonusDetail?.other) === other) {
                  return {}
                } else {
                  return data
                }
              }
              if (formValues.bonusType === 'promotion') {
                if (selectedTab === 'countries') {
                  const myShowBonusValidity = formValues?.showBonusValidity
                  delete formValues?.showBonusValidity
                  formValues.promotionTitle = safeStringify(data?.promoTitle)
                  formValues.description = safeStringify(data?.desc)
                  formValues.termCondition = safeStringify(data?.terms)
                  delete formValues?.loyaltyLevel
                  delete formValues?.paymentMethods
                  dispatch(
                    updateBonusStart({
                      data: {
                        ...formValues,
                        bonusId,
                        validFrom: formatDateYMD(state.map((a) => a.startDate)),
                        validTo: formatDateYMD(state.map((a) => a.endDate)),
                        // tenantIds: formValues.tenantIds.map((id) => id.value),
                        other: checkOther(safeStringify({ countries: countryData, showBonusValidity: myShowBonusValidity }))
                      },
                      navigate
                    })
                  )
                } else {
                  setSelectedTab(selectedTab === 'general'
                    ? (languages?.length ? 'languages' : 'countries')
                    : 'countries')
                }
              } else if (formValues.bonusType === 'freespins') {
                if (selectedTab === 'countries') {
                  const myShowBonusValidity = formValues?.showBonusValidity
                  delete formValues?.showBonusValidity
                  delete formValues?.loyaltyLevel
                  delete formValues?.paymentMethods
                  formValues.gameIds = gameIds
                  formValues.promotionTitle = safeStringify(data?.promoTitle)
                  formValues.description = safeStringify(data?.desc)
                  formValues.termCondition = safeStringify(data?.terms)
                  gameIds && gameIds?.length
                    ? dispatch(
                      updateBonusStart({
                        data: {
                          ...formValues,
                          bonusId,
                          validFrom: formatDateYMD(state.map((a) => a.startDate)),
                          validTo: formatDateYMD(state.map((a) => a.endDate)),
                          // tenantIds: formValues.tenantIds.map((id) => id.value),
                          other: checkOther({ betLevel: formValues?.betLevel, countries: countryData, showBonusValidity: myShowBonusValidity })
                        },
                        navigate
                      })
                    )
                    : toast('Select At least One Game.', 'error')
                } else {
                  setSelectedTab(selectedTab === 'general'
                    ? languages.length ? 'languages' : bonusDetail?.claimedCount ? 'countries' : 'currency'
                    : (selectedTab === 'languages'
                        ? bonusDetail?.claimedCount ? 'countries' : 'currency'
                        : selectedTab === 'currency' && (formValues?.isSticky === 'true' || formValues?.isSticky)
                          ? 'wageringContribution'
                          : selectedTab === 'wageringContribution' || selectedTab === 'currency' ? 'games' : 'countries'))
                }
              }  else if (formValues.bonusType === 'joining') {

                if (selectedTab === 'general' && bonusDetail?.claimedCount ) {
                  // const myShowBonusValidity = formValues?.showBonusValidity
                  delete formValues?.showBonusValidity
                  delete formValues?.loyaltyLevel
                  delete formValues?.paymentMethods
                  formValues?.appliedBonusId && delete formValues?.appliedBonusId
                  // formValues.gameIds = gameIds
                  formValues.promotionTitle = safeStringify(data?.promoTitle)
                  formValues.description = safeStringify(data?.desc)
                  formValues.termCondition = safeStringify(data?.terms)
                  // gameIds && gameIds?.length
                  dispatch(
                    updateBonusStart({
                        data: {
                          ...formValues,
                          bonusId,                          
                          validFrom: formatDateYMD(state.map((a) => a.startDate)),
                          validTo: formatDateYMD(state.map((a) => a.endDate)),
                          // tenantIds: formValues.tenantIds.map((id) => id.value),
                          // other: checkOther({ betLevel: formValues?.betLevel, countries: countryData, showBonusValidity: myShowBonusValidity })
                        },
                        navigate
                      })
                    )
                    // : toast('Select At least One Game.', 'error')
                }
                else if (selectedTab === 'currency') {
                  // const myShowBonusValidity = formValues?.showBonusValidity
                  delete formValues?.showBonusValidity
                  delete formValues?.loyaltyLevel
                  delete formValues?.paymentMethods
                  formValues?.appliedBonusId && delete formValues?.appliedBonusId
                  // formValues.gameIds = gameIds
                  formValues.promotionTitle = safeStringify(data?.promoTitle)
                  formValues.description = safeStringify(data?.desc)
                  formValues.termCondition = safeStringify(data?.terms)
                  // gameIds && gameIds?.length
                  dispatch(
                    updateBonusStart({
                        data: {
                          ...formValues,
                          bonusId,                          
                          validFrom: formatDateYMD(state.map((a) => a.startDate)),
                          validTo: formatDateYMD(state.map((a) => a.endDate)),
                          // tenantIds: formValues.tenantIds.map((id) => id.value),
                          // other: checkOther({ betLevel: formValues?.betLevel, countries: countryData, showBonusValidity: myShowBonusValidity })
                        },
                        navigate
                      })
                    )
                    // : toast('Select At least One Game.', 'error')
                } else {
                  setSelectedTab(bonusDetail?.claimedCount  ? 'general':               
                         selectedTab === 'general' ? "currency" : selectedTab === 'currency' && (formValues?.isSticky === 'true' || formValues?.isSticky))
          
                }
              }
              
              else {
                if (formValues.bonusType === 'balance') {
                  if (selectedTab === 'countries') {
                    const myShowBonusValidity = formValues?.showBonusValidity
                    delete formValues?.showBonusValidity
                    formValues.promotionTitle = safeStringify(data?.promoTitle)
                    formValues.description = safeStringify(data?.desc)
                    formValues.termCondition = safeStringify(data?.terms)
                    delete formValues?.paymentMethods
                    dispatch(
                      updateBonusStart({
                        data: {
                          ...formValues,
                          bonusId,
                          validFrom: formatDateYMD(state.map((a) => a.startDate)),
                          validTo: formatDateYMD(state.map((a) => a.endDate)),
                          appliedBonusId: formValues.appliedBonusVal,
                          other: checkOther(safeStringify({ countries: countryData, showBonusValidity: myShowBonusValidity }))
                        },
                        navigate
                      })
                    )
                  } else {
                    setSelectedTab(selectedTab === 'general'
                      ? (languages?.length ? 'languages' : 'countries')
                      : 'countries')
                  }
                } else {
                  if (selectedTab === 'countries') {
                    const myShowBonusValidity = formValues?.showBonusValidity
                    if (['depositCashback', 'wagering'].includes(formValues?.bonusType) && !bonusDetail?.claimedCount) {
                      for (let i = 0, len = formValues?.loyaltyLevel?.length; i < len; i++) {
                        delete formValues?.loyaltyLevel?.[i].startPoint
                        delete formValues?.loyaltyLevel?.[i].endPoint
                        formValues.loyaltyLevel[i].bonusPercentage = formValues?.loyaltyLevel?.[i].bonusPercentage / 100
                      }
                    }
                    delete formValues?.showBonusValidity
                    const timePeriod = formValues?.timePeriod
                    delete formValues?.timePeriod
                    formValues.promotionTitle = safeStringify(data?.promoTitle)
                    formValues.description = safeStringify(data?.desc)
                    formValues.termCondition = safeStringify(data?.terms)
                    formValues.paymentMethods = formValues?.paymentMethods ? safeStringify(formValues?.paymentMethods?.[bonusDetail?.tenantId]) : {}
                    dispatch(
                      updateBonusStart({
                        data: {
                          ...formValues,
                          bonusId,
                          validFrom: formatDateYMD(state.map((a) => a.startDate)),
                          validTo: formatDateYMD(state.map((a) => a.endDate)),
                          other: checkOther(safeStringify(formValues?.bonusType === 'deposit'
                            ? { countries: countryData, showBonusValidity: myShowBonusValidity }
                            : { loyaltyLevel: formValues?.loyaltyLevel, timePeriod, countries: countryData, showBonusValidity: myShowBonusValidity })),
                          loyaltyLevel: ''
                        },
                        navigate
                      })
                    )
                  } else {
      
                    setSelectedTab(selected => selected === 'general'
                      ? languages.length ? 'languages' : bonusDetail?.claimedCount ? 'countries' : 'currency'
                      : (selected === 'languages'
                          ? bonusDetail?.claimedCount ? bonusDetail?.bonusType === 'depositCashback' ? 'payment' : 'countries' : 'currency'
                          : selected === 'currency'
                            // ? ((formValues?.bonusType === 'wagering' || formValues?.bonusType === 'depositCashback') ? 'loyalty' : 'payment')
                            // : selectedTab === 'payment'
                              ? bonusDetail?.claimedCount ? 'countries' : 'wageringContribution'
                              : selectedTab === 'wageringContribution' ? 'countries' : 'wageringContribution'))
                  }
                }
              }
            }}
          >
            {({
              touched,
              errors,
              values,
              setSubmitting,
              handleChange,
              handleSubmit,
              handleBlur,
              setFieldValue
            }) => (
              <BForm>
                <Tabs
                  key={selectedTab}
                  activeKey={selectedTab}
                  className='nav-light'
                  onSelect={(k) => setSelectedTab(k)}
                  mountOnEnter
                  unmountOnExit
                >
                  <Tab disabled eventKey='general' title='General'>
                    <div className='mt-5'>
                      <GeneralForm
                        state={state}
                        setState={setState}
                        isEdit
                        setSelectedTab={setSelectedTab}
                        touched={touched}
                        errors={errors}
                        values={values}
                        setSubmitting={setSubmitting}
                        handleChange={handleChange}
                        handleSubmit={handleSubmit}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        bonusDetail={bonusDetail}
                        handleImagePreview={handleImagePreview}
                        preview={preview}
                        navigate={navigate}
                        clientsFilterData={clientsFilterData}
                        setSelectedClient={setSelectedClient}
                        portalOptions={portalOptions}
                        getBalanceBonusesOptions={getBalanceBonusesOptions}
                        balanceBonusOptions={balanceBonusOptions}
                        wageringTemplateList={wageringTemplateList}
                        setEnableSubmit={setEnableSubmit}
                        appliedBonusOptions={appliedBonusOptions}
                        data={data}
                        setData={setData}
                        languages={languages}
                        setCountryData={setCountryData}
                      />
                    </div>
                  </Tab>
                  {languages.length > 0 && values.bonusType !== 'joining'&&
                    <Tab disabled eventKey='languages' title='Languages'>
                      <div className='mt-5'>
                        <Languages
                          languages={languages}
                          handleSubmit={handleSubmit}
                          setSelectedTab={setSelectedTab}
                          selectedTab={selectedTab}
                          data={data}
                          setData={setData}
                          values={values}
                          isEdit
                          bonusDetail={bonusDetail}
                        />
                      </div>
                    </Tab>}
                  {values.bonusType !== 'balance' && !bonusDetail?.claimedCount && values.bonusType !== 'promotion' && (
                    <Tab disabled eventKey='currency' title='Currency'>
                      <div className='mt-3'>
                        <CurrenciesForm
                          isEdit
                          enableSubmit={enableSubmit}
                          setEnableSubmit={setEnableSubmit}
                          touched={touched}
                          errors={errors}
                          values={values}
                          setSubmitting={setSubmitting}
                          handleChange={handleChange}
                          handleSubmit={handleSubmit}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setCurr={setCurr}
                          bonusDetail={bonusDetail}
                          setSelectedTab={setSelectedTab}
                          setActiveTab={setActiveTab}
                        />
                      </div>
                    </Tab>
                  )}
{/* 
                  {values.bonusType === 'deposit' && (
                    <Tab
                      disabled
                      eventKey='payment'
                      title='Applies to Payment method'
                    >
                      <div className='mt-5'>
                        <PaymentMethod
                          touched={touched}
                          errors={errors}
                          values={values}
                          setSubmitting={setSubmitting}
                          handleChange={handleChange}
                          handleSubmit={handleSubmit}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setCurr={setCurr}
                          setSelectedTab={setSelectedTab}
                          setActiveTab={setActiveTab}
                          isEdit
                          selectedTab={selectedTab}
                          bonusDetail={bonusDetail}
                        />
                      </div>
                    </Tab>
                  )} */}
                  {bonusDetail?.bonusType !== 'balance' && !bonusDetail?.claimedCount && (
                    (bonusDetail?.bonusType !== 'freespins') && values.bonusType !== 'promotion'&&
                    values.bonusType !== 'joining'
                      ? (
                        <Tab
                          disabled
                          eventKey='wageringContribution'
                          title='Wagering contribution'
                        >
                          <div className='mt-5'>
                            <WageringContributionForm
                              state={state}
                              setState={setState}
                              setSelectedTab={setSelectedTab}
                              touched={touched}
                              errors={errors}
                              values={values}
                              setSubmitting={setSubmitting}
                              handleChange={handleChange}
                              handleSubmit={handleSubmit}
                              handleBlur={handleBlur}
                              setFieldValue={setFieldValue}
                              preview={preview}
                              handleImagePreview={handleImagePreview}
                              navigate={navigate}
                              dispatch={dispatch}
                              wageringTemplateList={wageringTemplateList}
                              wageringTemplateDetail={wageringTemplateDetail}
                              limit={limit}
                              pageNo={pageNo}
                              setLimit={setLimit}
                              setPageNo={setPageNo}
                              totalPages={totalPages}
                              selectedTab={selectedTab}
                              selectedClient={selectedClient}
                              isEdit
                            />
                          </div>
                        </Tab>
                        )
                      : values?.isSticky && !bonusDetail?.claimedCount &&
                        <Tab
                          disabled
                          eventKey='wageringContribution'
                          title='Wagering contribution'
                        >
                          <div className='mt-5'>
                            <WageringContributionForm
                              state={state}
                              setState={setState}
                              setSelectedTab={setSelectedTab}
                              touched={touched}
                              errors={errors}
                              values={values}
                              setSubmitting={setSubmitting}
                              handleChange={handleChange}
                              handleSubmit={handleSubmit}
                              handleBlur={handleBlur}
                              setFieldValue={setFieldValue}
                              preview={preview}
                              handleImagePreview={handleImagePreview}
                              navigate={navigate}
                              dispatch={dispatch}
                              wageringTemplateList={wageringTemplateList}
                              wageringTemplateDetail={wageringTemplateDetail}
                              limit={limit}
                              pageNo={pageNo}
                              setLimit={setLimit}
                              setPageNo={setPageNo}
                              totalPages={totalPages}
                              selectedTab={selectedTab}
                              selectedClient={selectedClient}
                              isEdit
                            />
                          </div>
                        </Tab>
                  )}
                  {(values.bonusType === 'freespins') && !bonusDetail?.claimedCount && (
                    <Tab disabled eventKey='games' title='Games'>
                      <div className='mt-5'>
                        <Games
                          gameIds={gameIds}
                          setGameIds={setGameIds}
                          setLimit={setGamesLimit}
                          setPageNo={setGamesPageNo}
                          setSearch={setSearch}
                          search={search}
                          totalPages={totalPages}
                          limit={gamesLimit}
                          pageNo={gamesPageNo}
                          handleSubmit={handleSubmit}
                          handleBlur={handleBlur}
                          casinoGamesData={casinoGamesData}
                          selectedProvider={selectedProvider}
                          setSelectedProvider={setSelectedProvider}
                          setSelectedTab={setSelectedTab}
                          isEdit
                          values={values}
                        />
                      </div>
                    </Tab>
                  )}
                 {values.bonusType !== 'joining' && <Tab disabled eventKey='countries' title='Countries'>
                    <div className='mt-5'>
                      <BonusCountry
                        data={countryData}
                        setData={setCountryData}
                        values={values}
                        setSelectedTab={setSelectedTab}
                        handleSubmit={handleSubmit}
                        languages={languages}
                        isEdit
                        bonusDetail={bonusDetail}
                      />
                    </div>
                  </Tab>}
                </Tabs>
              </BForm>
            )}
          </Formik>
          )
        : (
          <Preloader />
          )}
    </>
  )
}

export default EditBonus
